<template>
  <div class="filter-doctor">
    <!-- 左 -->
    <div class="receive-left receive-style">
      <div class="title">
        <span>未选用户</span>
        <span>{{ notSelection.length }}/{{ notTotalNum }}</span>
      </div>
      <el-table v-if="areaList.length"
                v-loading="tableLoading"
                class="not-choose"
                ref="notTableRef"
                :data="notTableData"
                @selection-change="notSelect"
                style="width: 100%">
        <el-table-column type="selection"
                         align="center"
                         :selectable="isNotSelect"
                         width="55">
        </el-table-column>
        <el-table-column label="姓名"
                         align="center"
                         prop="doctor_name">
        </el-table-column>
        <el-table-column label="手机"
                         align="center"
                         width="180"
                         prop="phone">
        </el-table-column>
        <el-table-column label="省市"
                         align="center"
                         width="140"
                         prop="area">
        </el-table-column>

        <el-table-column class-name='search-box'
                         align="right">
          <!-- eslint-disable -->
          <template slot="header"
                    slot-scope="scope">
            <el-input v-model="notSearch.keywords"
                      class="doctor-input"
                      size="mini"
                      clearable
                      @input="searchList"
                      placeholder="输入关键字搜索" />
            <el-cascader placeholder="请选择省市"
                         size="mini"
                         v-model="notSearch.doctor_area"
                         :options="areaList"
                         :props="areaTypeSet"
                         @change="searchList"
                         clearable
                         filterable></el-cascader>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination v-show="notTotalNum>0"
                  :total="notTotalNum"
                  :page.sync="notPagination.page"
                  :limit.sync="notPagination.pageNumber"
                  layout="total, prev, pager, next"
                  @pagination="getReceiveList" />
      <div class="empty"
           v-show="notTotalNum==0"></div>

    </div>

    <div class="receive-controls">
      <el-button type="primary"
                 icon="el-icon-arrow-left"
                 :disabled="!yesSelection.length"
                 @click="clickLeft"></el-button>
      <el-button type="primary"
                 :disabled="!notSelection.length"
                 @click="clickRight"><i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </div>

    <!-- 右 -->
    <div class="receive-right receive-style">
      <div class="title">
        <span>已选用户</span>
        <span>{{ yesSelection.length }}/{{ yesTableData.length }}</span>
      </div>

      <el-table v-if="areaList.length"
                class="yes-choose"
                :data="getYesTableData"
                @selection-change="yesSelect"
                ref="yesTableRef"
                style="width: 100%">
        <el-table-column type="selection"
                         align="center"
                         :selectable="isYesSelect"
                         width="55">
        </el-table-column>
        <el-table-column label="姓名"
                         align="center"
                         prop="doctor_name">
        </el-table-column>
        <el-table-column label="手机"
                         align="center"
                         width="180"
                         prop="phone">
        </el-table-column>
        <el-table-column label="省市"
                         align="center"
                         width="140"
                         prop="area">
        </el-table-column>

        <el-table-column class-name='search-box'
                         align="right">
          <!-- eslint-disable -->
          <template slot="header"
                    slot-scope="scope">
            <el-input v-model="yesSearch.keywords"
                      class="doctor-input"
                      size="mini"
                      clearable
                      placeholder="输入关键字搜索" />
            <el-cascader placeholder="请选择省市"
                         size="mini"
                         v-model="yesSearch.doctor_area"
                         :options="areaList"
                         :props="areaTypeSet"
                         @change="handleItemChange"
                         clearable
                         filterable></el-cascader>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination v-show="yesTotalNum>0"
                  :total="yesTotalNum"
                  :page.sync="yesPagination.page"
                  :limit.sync="yesPagination.pageNumber"
                  layout="total, prev, pager, next"
                  @pagination="searchYesList" />
      <div class="empty"
           v-show="yesTotalNum==0"></div>

    </div>
  </div>
</template>

<script>
import message from '../../../api/message';
import platform from '@/api/platform';
import session from '../../../service/utils/sessionStorage';
import Pagination from '../../../components/Pagination/index';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      input: '',
      notTableData: [],
      notTotalNum: 0,
      notPagination: {
        page: 1,
        pageNumber: 10
      },
      notSearch: {
        keywords: '',
        doctor_area: ''
      },
      yesTableData: [],
      chunkYesTableData: [],
      copyYesTableData: [],
      yesTotalNum: 0,
      yesPagination: {
        page: 1,
        pageNumber: 10
      },
      yesSearch: {
        keywords: '',
        doctor_area: ''
      },
      notSelection: [],
      yesSelection: [],
      areaList: [],
      areas: [],
      areaTypeSet: {
        value: 'value',
        label: 'label',
        children: 'children'
      },
      pageNum: 1
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    getYesTableData() {
      if (!this.chunkYesTableData.length) {
        return;
      }
      let data = [];
      let index = this.yesPagination.page - this.pageNum;
      index = index < 0 ? 0 : index;
      if (this.areas.length) {
        data = this.chunkYesTableData[index].filter((data) => {
          return (
            data.province_name.includes(this.areas[0].label) ||
            data.city_name.includes(this.areas[1].label)
          );
        });

        data = data.filter((data) => {
          return data.doctor_name
            .toLowerCase()
            .includes(this.yesSearch.keywords.toLowerCase());
        });
        return data;
      }

      data = this.chunkYesTableData[index].filter((data) => {
        return data.doctor_name
          .toLowerCase()
          .includes(this.yesSearch.keywords.toLowerCase());
      });
      return data;
    }
  },
  watch: {
    yesTableData: function (newVal, oldVal) {
      this.yesTotalNum = newVal.length;
      this.chunkYesTableData = _.chunk(JSON.parse(JSON.stringify(newVal)), 10);
    }
  },
  created() {
    this.getProvince();
    this.getReceiveList();
  },
  methods: {
    emit() {
      let params = this.yesTableData.map((item) => {
        return item.doctor_id;
      });
      this.$emit('filteruser', params);
    },
    isNotSelect(row, index) {
      row.notIndex = index;
      return row.isChecked;
    },
    notSelect(val) {
      // console.log(val);
      this.notSelection = val;
    },
    chunkYes() {
      this.copyYesTableData = this.chunkYesTableData;
    },
    clickRight() {
      this.pageNum = 1;
      this.yesTableData.push(...this.notSelection);
      for (let item of this.yesTableData) {
        for (let key of this.notTableData) {
          if (item.doctor_id == key.doctor_id) {
            key.isChecked = false;
          }
        }
      }
      this.chunkYes();
      this.$refs.notTableRef.clearSelection();
      // console.log(this.notSelection);
      this.emit();
    },
    isYesSelect(row, index) {
      row.yesIndex = index;
      return true;
    },
    yesSelect(val) {
      // console.log(val);
      this.yesSelection = val;
    },
    clickLeft() {
      this.pageNum = 2;
      let data = JSON.parse(JSON.stringify(this.yesTableData));
      for (let item of this.yesSelection) {
        data.forEach((yItem, index) => {
          if (item.doctor_id === yItem.doctor_id) {
            delete data[index];
          }
        });

        for (let key of this.notTableData) {
          if (item.doctor_id === key.doctor_id) {
            key.isChecked = true;
          }
        }
      }
      this.yesTableData = data.filter((val) => val);
      this.chunkYes();
      this.emit();
    },
    searchList() {
      this.notPagination.page = 1;
      this.getReceiveList();
    },
    searchYesList() {
      this.copyYesTableData =
        this.chunkYesTableData[this.yesPagination.page - 1];
    },
    //获取地区数据
    getProvince() {
      platform.getProvinceCityDistrict().then((res) => {
        let tree = res.data.list;
        this.transRegions(tree);
        this.areaList = tree;
      });
    },
    transRegions(tree) {
      tree.forEach((item) => {
        if (item.city || item.district) {
          item.children = item.city || item.district;
          delete item.city;
          delete item.district;
          this.transRegions(item.children);
        }
        if (item.province_id) {
          item.value = item.province_id;
          delete item.province_id;
        }
        if (item.city_id) {
          item.value = item.city_id;
          delete item.city_id;
        }
        if (item.district_id) {
          item.value = item.district_id;
          delete item.district_id;
        }
        if (item.name) {
          item.label = item.name;
          delete item.name;
        }
      });
    },
    handleItemChange() {
      let getCascaderObj = function (val, opt) {
        return val.map(function (value, index, array) {
          for (var itm of opt) {
            if (itm.value == value) {
              opt = itm.children;
              return itm;
            }
          }
          return null;
        });
      };
      this.areas = getCascaderObj(this.yesSearch.doctor_area, this.areaList);
      // console.log(this.areas);
    },
    // 获取医生列表
    getReceiveList() {
      this.tableLoading = true;
      let obj = {
        keywords: this.notSearch.keywords,
        province_id: this.notSearch.doctor_area[0],
        city_id: this.notSearch.doctor_area[1],
        district_id: this.notSearch.doctor_area[2]
      };
      let params = Object.assign(this.notPagination, obj);
      message.getPushDoctorList(params).then((res) => {
        let { list, totalPage, total } = res.data;

        list = list.map((item) => {
          item.isChecked = true;
          if (item.province_name == item.city_name) {
            item.area = item.province_name;
          } else {
            item.area = `${item.province_name}${item.city_name}`;
          }
          return item;
        });
        for (let item of this.yesTableData) {
          for (let listItem of list) {
            if (item.doctor_id == listItem.doctor_id) {
              listItem.isChecked = false;
            }
          }
        }
        this.notTableData = list;
        this.notTotalNum = total;
        this.tableLoading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-doctor {
  display: flex;
  align-items: center;
  .receive-style {
    width: 460px;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    border-bottom-right-radius: 2px;
    box-sizing: border-box;
    position: relative;
    .title {
      background-color: #f5f7fa;
      border-bottom: 1px solid #ebeef5;
      padding: 0 10px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      display: flex;
      justify-content: space-between;
      color: #707070;
      margin-bottom: 40px;
    }
    .pagination-container {
      padding: 0;
    }
    .empty {
      height: 44px;
    }
    .el-table {
      position: static;
      ::v-deep .el-table__body-wrapper {
        overflow-x: hidden;
        height: 500px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
          background-color: #f5f7fa;
        }

        &::-webkit-scrollbar {
          width: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background: #669961;
          border-radius: 20px;
        }
      }
      ::v-deep .el-table__header-wrapper {
        height: 56px;
        border-bottom: 1px solid #ebeef5;
      }
    }

    ::v-deep .search-box {
      width: 100%;
      position: absolute;
      top: 60px;
      left: 0;
      padding: 0;
      border: 0;
      .cell {
        display: flex;
        justify-content: space-around;
        .doctor-input {
          width: 160px;
        }
      }
    }
  }
  .receive-controls {
    margin: 0 20px;
  }
  ::v-deep .pagination-container {
    .el-pagination {
      padding: 10px 0 10px 10px;
      display: flex;
      align-items: center;
      .el-pager {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>